var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('Logo')],1),_c('v-row',[_c('v-col',{attrs:{"lg":"12"}},[_c('h3',{staticClass:"mt-5",attrs:{"align":"center"}},[_c('b',[_vm._v(" "+_vm._s(_vm.message)+" ")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }